let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("it51I")).then(() => parcelRequire('3bBro'));